import type { MapData, MapId } from '../engine/types.js';
import { STANDARD_MAP } from './standard-map.js';
import { GOLARION_MAP } from './golarion-map.js';

/** Every map the app ships, by id. */
export const MAPS: Record<MapId, MapData> = {
  standard: STANDARD_MAP,
  golarion: GOLARION_MAP,
};

export const MAP_IDS: readonly MapId[] = ['standard', 'golarion'];

/** The map a state is on: its `map` field, or the standard map when that is absent. */
export function mapOf(state: { map?: MapId }): MapData {
  return MAPS[state.map ?? 'standard'] ?? STANDARD_MAP;
}
